import { Vue, newVue } from '@/config/vue'

On.VueInit({
  init() {
    const BottomBanner = Vue.component('bottom-banner', () =>
      import(/* webpackChunkName: "bottom-banner" */ './BottomBanner.vue')
    )
    newVue({
      render: h => h(BottomBanner),
      mount: '.js-vue-bottom-banner',
    })
  },
})
window.On.BottomBanner = { init() {} }
